import { guidEmpty } from 'utils/guid-empty';

export class PessoaParametroResponseModel {
  constructor(
    public id: string | null = guidEmpty(),
    public pessoaId: string = guidEmpty(),
    public parametroId: string = guidEmpty(),
    public descricao: string = '',
    public valor: string = '',
    public padrao: boolean = false,
  ) {}
}
